var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "c-filter is-sticky", attrs: { id: "c-filter" } },
      [
        _c("map-filter", {
          attrs: {
            "map-taxonomy": _vm.mapTaxonomy,
            "checked-filters": _vm.checkedFilters,
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "c-map" },
      [
        _vm._m(0),
        _vm._v(" "),
        _c("map-feed", {
          attrs: {
            "filtered-map-data": _vm.filteredMapData,
            showme: _vm.showme,
            "highlight-marker": _vm.highlightMarker,
            "stop-highlight-marker": _vm.stopHighlightMarker,
            "visibility-changed": _vm.visibilityChanged,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "c-map__view-wrapper" }, [
      _c("div", { staticClass: "c-map__view", attrs: { id: "c-map__view" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// /Users/justin/Sites/southleft/504healthnet/wp-content/themes/healthy-hospitality/resources/assets/app/components/app.vue